import React, { Component } from 'react'
import Search from './Search'
import Table from './Table'
import EditSchedule from './EditSchedule'
import store from './store'
import { HeaderView } from '@merchant-backend/common-components'
import { Button } from 'hljd'
import editScheduleStore from './EditSchedule/store'

export default class extends Component {
  componentDidMount() {
    store.getHotelHalls()
    store.getMerchantInfo()
  }

  render() {
    return (
      <HeaderView
        title="列表模式"
        extra={
          <Button type="primary" onClick={editScheduleStore.addSchedule}>
            新建档期
          </Button>
        }
      >
        <Search />
        <Table />
        <EditSchedule />
      </HeaderView>
    )
  }
}
